<template>
  <div id="DocumentLimitTransactionSign">
    <SignatureDialog
      @close="isSignPadOpen = false"
      @sign-success="sign($event)"
      v-if="isSignPadOpen"
      :username="user.name"
    />
    <div class="sun not-full sign">
      <p class="title">
        {{date.format('YYYY')}}년
        <strong>{{date.format('MM')}}</strong>월
        <strong>{{date.format('DD')}}</strong>일
      </p>
      <p class="title">
        성명
        <strong>{{user.name}}</strong>
      </p>
      <div v-ripple @click="isSignPadOpen = true" class="sign-box shadow">
        <p v-if="!signImg" class="sign-guide">본인의 성함을 정자로 서명해주세요.</p>
        <img v-else :src="signImg" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SignatureDialog from '@/components/modal/SignatureDialog'
import AuthService from '@/service/auth/AuthService'

// Function Section
function dataURIToBlob(dataURI) {
  let splitDataURI = dataURI.split(',')
  let byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  let mimeString = splitDataURI[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export default {
  name: 'DocumentLimitTransactionSign',
  components: {
    SignatureDialog,
  },
  data() {
    return {
      user: null,
      signImg: null,
      date: null,
      isSignPadOpen: false,
      isAgreed: false,
      isLoading: false
    }
  },
  async created() {
    this.user = AuthService.getProfile()
    this.date = moment()
  },
  methods: {
    sign(data) {
      this.signImg = data
      this.isSignPadOpen = false
      this.$emit('complete')
      this.$emit('setSignature', dataURIToBlob(data))
    },
  }
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionSign {
    width: 100%;
    display: flex;

    strong {
      display: inline-block;
    }
    .sign {
      width: 100%;
      margin-top: 20px;
      .title {
        width: 100%;
        text-align: center;
        line-height: 26px;
      }
      .sign-box {
        width: 100%;
        height: 18vh;
        margin: 20px 0 30px 0;
        border-radius: 4px;
        box-shadow: 0 8px 18px 0 rgba(32, 35, 36, 0.08);
        .sign-guide {
          line-height: 18vh;
          text-align: center;
          color: #8a94a2;
        }
        img {
          height: 100%;
          margin: auto;
          display: block;
        }
      }
    }
  }
</style>
